import SearchBarPanel from './SearchBarPanel.jsx';

export default SearchBarPanel;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarSmall/SearchBarPanel/index.js